import script from "./CreateBrandDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateBrandDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateBrandDialog.vue?vue&type=style&index=0&id=b3148458&lang=css"
import "./CreateBrandDialog.vue?vue&type=style&index=1&id=b3148458&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3148458"]])

export default __exports__